import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { Guid } from "./Guid";

export class DtoBase implements ObjectSerializer {

	public GUID: string;
	public CreatedTime: string;
	public ModifiedTime: string;

	constructor(other?: DtoBase) {
		if (other)
			this.CopyPersistenceProps(other);
		else
			this.ClearPersistenceProps();
	}

	public get HasGUID(): boolean {
		return !!this.GUID;
	}

	public get HasModifiedTime(): boolean {
		return !!this.ModifiedTime;
	}

	public get HasCreatedTime(): boolean {
		return !!this.CreatedTime;
	}

	public ClearPersistenceProps(): void {
		this.GUID = "";
		this.CreatedTime = "";
		this.ModifiedTime = "";
	}

	public CopyPersistenceProps(other: DtoBase): void {
		this.GUID = other.GUID;
		this.CreatedTime = other.CreatedTime;
		this.ModifiedTime = other.ModifiedTime;
	}

	public VerifyGuid(): string {
		if (!this.GUID) {
			this.GUID = Guid.Create().toString().toLowerCase();
		}
		return this.GUID;
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof DtoBase))
			return false;
		let other: DtoBase = (obj as DtoBase);

		return (this.GUID === other.GUID &&
			this.CreatedTime === other.CreatedTime &&
			this.ModifiedTime === other.ModifiedTime);
	}

	public Write(obj: any, context: any): void {
		if (this.HasGUID)
			obj.guid = this.GUID;

		if (this.HasCreatedTime)
			obj.created_time = this.CreatedTime;

		if (this.HasModifiedTime)
			obj.modified_time = this.ModifiedTime;
	}

	public Read(obj: any, context: any): void {
		if (obj.guid !== undefined)
			this.GUID = obj.guid;

		if (obj.created_time !== undefined)
			this.CreatedTime = obj.created_time;

		if (obj.modified_time !== undefined)
			this.ModifiedTime = obj.modified_time;
	}

}

